import app from '../../main';
import { http } from '../../axios';

function getState() {
  return {
    loading: {
      accountBalance: false,
      tariffData: false,
      history: false,
      availableTariffs: false,
    },

    accountBalance: null,
    tariffData: null,
    history: null,
    availableTariffs: null,
  };
}

function onRequestError(title, message = 'Please check your internet connection or try gain later') {
  return () => {
    app.$vModal.open('warning', { title, message });
  };
}

export default {
  namespaced: true,
  state: getState(),
  actions: {
    async loadAccountBalance({ commit }) {
      commit('setLoadingProperty', ['accountBalance', true]);

      const { data } = await http.get('/api/cabinet/employer/wallet/get-balance')
        .catch(onRequestError('Failed to load account balance'));

      commit('setProperty', ['accountBalance', data.data]);
      commit('setLoadingProperty', ['accountBalance', false]);

      return data.data;
    },
    async loadTariffData({ commit }) {
      commit('setLoadingProperty', ['tariffData', true]);

      const { data } = await http.get('/api/cabinet/employer/subscribe/tariff-get')
        .catch(onRequestError('Failed to load account subscription'));

      commit('setProperty', ['tariffData', data.data]);
      commit('setLoadingProperty', ['tariffData', false]);

      return data.data;
    },
    async loadHistory({ commit }) {
      commit('setLoadingProperty', ['history', true]);

      const { data } = await http.get('/api/cabinet/employer/subscribe/history-get')
        .catch(onRequestError('Failed to load account subscription'));

      commit('setProperty', ['history', data.data]);
      commit('setLoadingProperty', ['history', false]);

      return data.data;
    },
    async loadAvailableTariffs({ commit }) {
      commit('setLoadingProperty', ['availableTariffs', true]);

      const { data } = await http.get('/api/cabinet/employer/subscribe/get-tariffs')
        .catch(onRequestError('Failed to load available tariffs'));

      commit('setProperty', ['availableTariffs', data.data]);
      commit('setLoadingProperty', ['availableTariffs', false]);
    },
    async purchaseTariff(_, tariff) {
      await http.post('/api/cabinet/employer/subscribe/purchase-tariff', { tariff_id: tariff.id });
    },
  },
  mutations: {
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return;
      state[key] = value;
    },
    setLoadingProperty(state, [key, value]) {
      if (!state.loading.hasOwnProperty(key)) return;
      state.loading[key] = value;
    },
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    balance(state) {
      return state.accountBalance || { balance: '0.00', currency: 'UAH/₴' };
    },
    tariff(state) {
      return state.tariffData?.tariff;
    },
    actionsStats(state) {
      return state.tariffData?.action_list;
    },
    history(state) {
      return state.history || [];
    },
    availableTariffs(state) {
      return state.availableTariffs || [];
    },
  },
};
